const localStorageKeys = {
  emptyBanner: 'empty-banner',
  social: {
    brandId: 'current_brand_id',
    targetTab: 'current_target_tab',
  },
  messages: {
    // Deliberately a separate key from social.brandId — brand selection stays
    // independent between the two sections (decided explicitly, not shared).
    brandId: 'messages_current_brand_id',
    smsVerificationDraft: 'messages_sms_verification_draft',
  },
  jooiceAi: {
    message: 'ai-message',
  },
  listing: {
    platformsUpdateBanner: 'listing_platforms_update_banner_dismissed',
    // Suffixed with the location id: each location has its own onboarding.
    dismissedNextSteps: 'listing_dismissed_next_steps',
  },
  commons: {
    countryPreference: 'country_preference',
  },
  reputation: {
    defaultGating: 'default_gating_value',
  },
};

export default localStorageKeys;
